
import * as plotUtil from '../plot_util'

/** 进攻箭头 */
const attack_arrow_opts = {
    headHeightFactor: 0.18,
    headWidthFactor: 0.3,
    neckHeightFactor: 0.85,
    neckWidthFactor: 0.15,
    headTailFactor: 0.8
}

const HALF_PI = Math.PI / 2

export const getAttackArrowHeadPoints = function (points) {
    let len = plotUtil.getBaseLength(points);
    let headHeight = len * attack_arrow_opts.headHeightFactor;
    let headPnt = points[points.length - 1];
    let headWidth = headHeight * attack_arrow_opts.headWidthFactor;
    let neckWidth = headHeight * attack_arrow_opts.neckWidthFactor;
    let neckHeight = headHeight * attack_arrow_opts.neckHeightFactor;
    let headEndPnt = plotUtil.getThirdPoint(points[points.length - 2], headPnt, 0, headHeight, true);
    let neckEndPnt = plotUtil.getThirdPoint(points[points.length - 2], headPnt, 0, neckHeight, true);
    let headLeft = plotUtil.getThirdPoint(headPnt, headEndPnt, HALF_PI, headWidth, false);
    let headRight = plotUtil.getThirdPoint(headPnt, headEndPnt, HALF_PI, headWidth, true);
    let neckLeft = plotUtil.getThirdPoint(headPnt, neckEndPnt, HALF_PI, neckWidth, false);
    let neckRight = plotUtil.getThirdPoint(headPnt, neckEndPnt, HALF_PI, neckWidth, true);
    return [neckLeft, headLeft, headPnt, headRight, neckRight];
}

export const getAttackArrowBodyPoints = function (points, neckLeft, neckRight, tailWidthFactor) {
    let allLen = plotUtil.wholeDistance(points);
    let len = plotUtil.getBaseLength(points);
    let tailWidth = len * tailWidthFactor;
    let neckWidth = plotUtil.distance(neckLeft, neckRight);
    let widthDif = (tailWidth - neckWidth) / 2;
    let tempLen = 0, leftBodyPnts = [], rightBodyPnts = [];
    for (let i = 1; i < points.length - 1; i++) {
        let angle = plotUtil.getAngleOfThreePoints(points[i - 1], points[i], points[i + 1]) / 2;
        tempLen += plotUtil.distance(points[i - 1], points[i]);
        let w = (tailWidth / 2 - tempLen / allLen * widthDif) / Math.sin(angle);
        let left = plotUtil.getThirdPoint(points[i - 1], points[i], Math.PI - angle, w, true);
        let right = plotUtil.getThirdPoint(points[i - 1], points[i], angle, w, false);
        leftBodyPnts.push(left);
        rightBodyPnts.push(right);
    }
    return leftBodyPnts.concat(rightBodyPnts);
}

export default function (coordinates) {
    if (coordinates.length < 3) return [coordinates];
    let [tailLeft, tailRight] = coordinates;
    if (plotUtil.isClockWise(coordinates[0], coordinates[1], coordinates[2])) {
        tailLeft = coordinates[1];
        tailRight = coordinates[0];
    }
    let midTail = plotUtil.mid(tailLeft, tailRight);
    let bonePnts = [midTail].concat(coordinates.slice(2));
    // 计算箭头
    let headPnts = getAttackArrowHeadPoints(bonePnts, tailLeft, tailRight);
    let neckLeft = headPnts[0];
    let neckRight = headPnts[4];
    let tailWidthFactor = plotUtil.distance(tailLeft, tailRight) / plotUtil.getBaseLength(bonePnts);
    // 计算箭身
    let bodyPnts = getAttackArrowBodyPoints(bonePnts, neckLeft, neckRight, tailWidthFactor);
    // 整合
    let count = bodyPnts.length;
    let leftPnts = [tailLeft].concat(bodyPnts.slice(0, count / 2));
    leftPnts.push(neckLeft);
    let rightPnts = [tailRight].concat(bodyPnts.slice(count / 2, count));
    rightPnts.push(neckRight);

    leftPnts = plotUtil.getQBSplinePoints(leftPnts);
    rightPnts = plotUtil.getQBSplinePoints(rightPnts);

    return [leftPnts.concat(headPnts, rightPnts.reverse())]
}